import { useEffect } from "react";
import { useAgentFaviconBootstrap } from "modules/settings/api";
import { applyFavicon, persistFavicon } from "utils/favicon";

/**
 * Fetches the tenant's saved favicon once per app session and applies it —
 * so the ERP shows it the first time it is opened, on whichever page, rather
 * than only after a visit to Settings. `useAgentFaviconBootstrap` is a no-op
 * for a user without `AGENT_OPTIONS_INDEX` (most users): that browser falls
 * back to whatever `initFavicon()` already cached from a previous session,
 * or the default. Call it from an always-mounted, authenticated-only tree
 * (e.g. `AppRoutes`) — the query itself no-ops before login, since
 * `HAS_PERMISSION` reads no permissions out of an empty `user` record.
 */
export const useFaviconBootstrap = () => {
  const { data } = useAgentFaviconBootstrap();

  useEffect(() => {
    if (!data) return;

    const favicon_url = data?.company_info?.favicon_url || null;
    applyFavicon(favicon_url);
    persistFavicon(favicon_url);
  }, [data]);
};
